import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class GlobalUserUnitPermissionService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }
    get({userId, organizationId}) {
        return Vue.axios.get(`${API_HOST}/api/GlobalUserUnitPermission`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                userId : userId,
                organizationId: organizationId
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getBySelectedUser({userId}) {
        return Vue.axios.get(`${API_HOST}/api/GlobalUserUnitPermission`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                userId : userId
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }


    editUnit({userId, unitId, isActive}) {
        return Vue.axios.put(`${API_HOST}/api/GlobalUserUnitPermission/unit`, {
            userId: userId,
            unitId: unitId,
            isActive: isActive
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    editOrganization({userId, organizationId, isActive}) {
        return Vue.axios.put(`${API_HOST}/api/GlobalUserUnitPermission/organization`, {
            userId: userId,
            organizationId: organizationId,
            isActive: isActive
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

    copyFromUser({fromId, toId}) {
        return Vue.axios.post(`${API_HOST}/api/GlobalUserUnitPermission`, {
            FromId: fromId,
            ToId: toId,
        }, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            }
        })
    }

}

export default new GlobalUserUnitPermissionService()
